module.exports = __webpack_public_path__ + "static/alex-e0b46011967fc058ff8fdbac2599b55f.jpg";